module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<%\nvar title = model.title;\nvar text = model.text;\nif(environment.style == 'mobile') {\ntitle = (model.titleMobile != \"\" ? model.titleMobile : title);\ntext = (model.textMobile != \"\" ? model.textMobile : text);\n}\n%>\n<div class=\"texts <%= model.textColor.data %>\">\n<h3><%- title %></h3>\n<%- text %>\n<%- include('../../button/button', { model: model }); %>\n</div>\n<div class=\"images\">\n<%      var i1 = (helpers.detectRenderedImage(model.img, model._img) || {}).rendered || {};\nif (environment.device && environment.device.type==\"bot\") {\n%>          <img src=\"<%= i1.url %>\" alt=\"<%= i1.alt %>\" title=\"<%= i1.title %>\">\n<%      } else { %>\n<div style=\"background-image:url(<%= i1.url %>)\"></div>\n<%      } %>\n</div>\n</div>"
  , __filename = "components/templates/project/presentation/presentation.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n")
    ; __line = 2
    ; 
var title = model.title;
var text = model.text;
if(environment.style == 'mobile') {
title = (model.titleMobile != "" ? model.titleMobile : title);
text = (model.textMobile != "" ? model.textMobile : text);
}

    ; __line = 9
    ; __append("\n<div class=\"texts ")
    ; __line = 10
    ; __append(escapeFn( model.textColor.data ))
    ; __append("\">\n<h3>")
    ; __line = 11
    ; __append( title )
    ; __append("</h3>\n")
    ; __line = 12
    ; __append( text )
    ; __append("\n")
    ; __line = 13
    ; __append( include('../../button/button', { model: model }) )
    ; __append("\n</div>\n<div class=\"images\">\n")
    ; __line = 16
    ;       var i1 = (helpers.detectRenderedImage(model.img, model._img) || {}).rendered || {};
if (environment.device && environment.device.type=="bot") {

    ; __line = 18
    ; __append("          <img src=\"")
    ; __append(escapeFn( i1.url ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( i1.alt ))
    ; __append("\" title=\"")
    ; __append(escapeFn( i1.title ))
    ; __append("\">\n")
    ; __line = 19
    ;       } else { 
    ; __append("\n<div style=\"background-image:url(")
    ; __line = 20
    ; __append(escapeFn( i1.url ))
    ; __append(")\"></div>\n")
    ; __line = 21
    ;       } 
    ; __append("\n</div>\n</div>")
    ; __line = 23
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/project/presentation/presentation.ejs

}